import { Injectable } from '@angular/core';
import { EntityOperations, SystemEntity } from '@wdx/clmi/clmi-swagger-gen';
import { Observable } from 'rxjs';
import { BaseApiService } from '../base-api.service';

@Injectable({
    providedIn: 'root',
})
export class EntityService extends BaseApiService {
    deleteEntity(
        entityType: SystemEntity,
        entityId: string,
    ): Observable<EntityOperations> {
        return this.delete(`${entityType?.toLowerCase()}/${entityId}`);
    }
}
